import { Alert } from 'antd'
import { useEditableFormState } from '../contexts/editableForm'
import { useFormContext } from '../createAppFormHook'

/**
 * Renders an inline error alert above the form with all submit and field messages.
 * Shows when either:
 * - The user attempted to submit and there are field errors, or
 * - The form meta contains submitErrors pushed by the submit bridge.
 */
export function FormAlerts() {
  const form = useFormContext()
  const submitErrors = useEditableFormState(s => s.meta.submitErrors)

  return (
    <form.Subscribe
      selector={s => ({
        submitCount: s.submitCount,
        errors: s.errors as Record<string, unknown[] | unknown> | undefined,
        // Allow custom meta flags stored by wrappers
        meta: (s as unknown as { meta?: { submitErrors?: string[] } }).meta,
      })}
    >
      {({ submitCount, errors, meta }) => {
        const fieldErrors: string[] = Object.values(errors ?? {})
          .flatMap(v => (Array.isArray(v) ? (v as unknown[]) : [v]))
          .filter(Boolean)
          .map(v => String(v))

        // Prefer the Zustand-driven submitErrors; keep TanStack meta fallback for safety
        const metaSubmitErrors = submitErrors && submitErrors.length > 0 ? submitErrors : (meta?.submitErrors ?? [])

        const show = (submitCount > 0 && fieldErrors.length > 0) || metaSubmitErrors.length > 0
        if (!show) return null

        const messages = [...metaSubmitErrors, ...fieldErrors]

        return (
          <div className="mb-3">
            <Alert
              type="error"
              title="Bitte prüfen"
              description={
                <div>
                  {messages.map(m => (
                    <div key={m}>{m}</div>
                  ))}
                </div>
              }
              showIcon
            />
          </div>
        )
      }}
    </form.Subscribe>
  )
}
